import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PHONE_TEL_URL, WHATSAPP_URL } from '../../constants';
import useLangPrefix from '../../hooks/useLangPrefix';
import './Hero.css';

const heroStyle = {
  backgroundImage: `linear-gradient(rgba(12, 18, 34, 0.75), rgba(12, 18, 34, 0.85)), url(${process.env.PUBLIC_URL}/Images/court.jpg)`,
};

function Hero() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();

  return (
    <section className="hero-section text-white" id="home" style={heroStyle}>
      <div className="container py-5 py-lg-6">
        <div className="row justify-content-center">
          <div className="col-lg-9 col-xl-8 text-center">
            <h1 className="display-5 fw-semibold mb-3">{t('hero.headline')}</h1>
            <p className="lead text-hero-sub mb-3">{t('hero.subheadline')}</p>
            <p className="text-hero-sub mb-4">{t('hero.description')}</p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              <a className="btn btn-light btn-lg px-4 text-navy fw-semibold" href={PHONE_TEL_URL} dir="ltr">
                {t('hero.ctaCall')}
              </a>
              <a
                className="btn btn-success btn-lg px-4 fw-semibold"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('hero.ctaWhatsapp')}
              </a>
              <Link
                className="btn btn-outline-light btn-lg px-4 fw-semibold"
                to={`${langPrefix}/practice-areas/lebanese-expat-lawyer-lebanon`}
              >
                {t('hero.ctaExpats')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
